import { ChangeDetectionStrategy, Component, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { FicScreenContentBase } from '../../fic-screen/fic-screen-content-base';
import { IForumLightWeight } from '@fi-shared/fi-forum/fi-forum';
import { FiForumSharedService } from '@fi-shared/fi-forum/fi-forum-shared.service';

@Component({
    selector: 'fi-forum-post-add-screen',
    template: `
        <fic-screen>
            <fic-screen-header>
                <fic-screen-header-prefix>
                    <fic-screen-btn-close></fic-screen-btn-close>
                </fic-screen-header-prefix>
                {{ 'forum.new_discussion' | fiAppText }}
            </fic-screen-header>
            <fic-screen-content>
                <fi-forum-post-add
                    [(forumId)]="data.forumId"
                    [availableForums]="availableForums"
                    (editCancelled)="onEditCancelled()"
                    (forumPostAdded)="onForumPostAdded()"
                ></fi-forum-post-add>
            </fic-screen-content>
        </fic-screen>
    `,
    styleUrls: ['./fi-forum-post-add-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forum-post-add-screen' },
    standalone: false,
})
export class FiForumPostAddScreenComponent extends FicScreenContentBase<{
    forumId: number;
    forumPostSaved: (forumId: number) => void;
}> {
    availableForums: IForumLightWeight[] = [];

    ngOnInit(): void {
        this.getLightWeightForums();
    }

    private getLightWeightForums() {
        this.injector
            .get(FiForumSharedService)
            .getForumsLightWeight()
            .then((result: IForumLightWeight[]) => {
                this.availableForums = result;
                this.injector.get(ChangeDetectorRef).detectChanges();
            });
    }

    onForumPostAdded() {
        this.data.forumPostSaved(this.data.forumId);
        this.closeScreen();
    }

    onEditCancelled() {
        this.closeScreen();
    }
}
